import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import BasicMenu from "./HeaderdropDown";

const UserHeader = () => {
  const navigate = useNavigate();
  const gotoOrderCrearte = (serviceType) => {
    navigate("/formpostal", { state: { serviceType: serviceType } });
  };
  return (
    <>
      <header className="main-header">
        <div className="container-fluid p-0">
          <div className="header-row d-flex justify-content-between align-items-center">
            <div className="header-logo">
              <NavLink to="/">
                {" "}
                <img src="/assets/images/OHC-Logo.png" alt="" />{" "}
              </NavLink>
            </div>

            <div className="header-middle">
              <div onClick={() => gotoOrderCrearte("order-booking")}>
                General/Regular Cleaning
              </div>
              <div onClick={() => gotoOrderCrearte("professional")}>
                Professional Cleaning
              </div>
            </div>
            <div className="header-login">
              <BasicMenu />
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default UserHeader;
